// src/components/OLTManage/OLTManage.jsx

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { DeviceProvider } from "./layout/DeviceContext";

import OLTList from "./OLTList";
import OLTLayout from "./layout/OLTLayout";

import DashboardHome from "./pages/DashboardHome";
import Ethernet from "./pages/Ethernet";
import Pon from "./pages/Pon";
import ONU from "./pages/ONU";
import Logs from "./pages/Logs";

import "./OLTManage.css"; // Global manage CSS

const OLTManage = () => {
    return (
        <DeviceProvider>
            <div className="olt-manage-wrapper">
                <Routes>
                    {/* ১. হোম/লিস্ট পেজ */}
                    <Route path="/" element={<OLTList />} />               

                    {/* ২. ড্যাশবোর্ড ও সাব-পেজসমূহ */}
                    <Route path="dashboard/:id" element={<OLTLayout />}>
                        <Route index element={<DashboardHome />} />
                        <Route path="ethernet" element={<Ethernet />} />
                        <Route path="pon" element={<Pon />} />
                        <Route path="onus" element={<ONU />} />
                        <Route path="logs" element={<Logs />} />
                    </Route>

                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </div>
        </DeviceProvider>
    );
};

export default OLTManage;